import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { GolfEvent } from '../../../../models/GolfEvent';
import { GolfEventService } from '../../../../services/golf-event.service';
import { ApplicationService } from '../../../../services/application.service';
import { AddEditPlayerComponent } from '../../../player/add-edit-player/add-edit-player.component';
import { Player } from '../../../../models/Player';
import { SelectableObject } from '../../../../models/viewmodels/selectableobject';
import { FormsModule } from '@angular/forms';
import { PlayerService } from '../../../../services/player.service';

@Component({
  selector: 'app-add-to-field',
  standalone: true,
  imports: [AddEditPlayerComponent, NgFor, NgIf, FormsModule],
  templateUrl: './add-to-field.component.html',
  styleUrl: './add-to-field.component.css'
})
export class AddToFieldComponent implements OnChanges {
  constructor(private golfEventService:GolfEventService, private applicationService:ApplicationService, private playerService:PlayerService) {}
  
  @Input() league:GolfEvent|null = null;
  @Output() playersAdded = new EventEmitter<void>;

  containerDisplay:string = 'LIST';
  players:Array<SelectableObject> = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['league'] && this.league) {
      this.getPlayers();
    }
  }

  async getPlayers() {
    if(!this.league) return;
    this.applicationService.showGlobalSpinner();
    let playerResult = await this.golfEventService.getPlayersNotInField(this.league.id);

    playerResult.forEach(pr => {
      this.players.push({
        obj: pr,
        isSelected: false
      });
    });

    this.applicationService.hideGlobalSpinner();
  }

  async newPlayerCreated(playerId:number) {
    this.applicationService.showGlobalSpinner();
    let player = await this.playerService.searchPlayers(playerId);
    this.players.push({isSelected: true, obj: player[0]});
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'LIST'
  }

  async addPlayersToField() {
    if(!this.league) return;
    let selectedPlayerIds = this.players.filter(p => p.isSelected).map(p => p.obj.id);
    this.applicationService.showGlobalSpinner();
    await this.golfEventService.addPlayersToField(this.league.id, selectedPlayerIds);
    this.applicationService.hideGlobalSpinner();
    this.playersAdded.emit();
  }
}
